import React, { Component } from 'react';
import { navigate } from '../modules/high_level_actions';
import { connect } from 'react-redux';
import TermsOfMembershipNegOp from './TermsOfMembershipNegOp.jsx';

class TermsOfMembership extends Component {
  render() {
    if( this.props.store.type ==="Negative Option") return <TermsOfMembershipNegOp />;
    let memberCreditCopy = `Each Member Credit can be redeemed at any time during the term of your membership for any book on the site – regardless of the price shown.`;
    if (this.props.store.type ==="Neglite") {
      memberCreditCopy = `Each Member Credit can be redeemed at any time during the term of your membership for any book on the site, provided that the membership price of the book does not exceed $35.`;
    }
    return (
      <div className="content-max-width cms">
        <div className="content-max-width">
          <a href="/" className="button btn-secondary float-right" onClick={(evt) => this.props.dispatch(navigate(evt))}>&times;</a>
          <h2>{this.props.store.name} Member Terms</h2>
        </div>
        <div className="modal-body">
          <p>
            Welcome to The {this.props.store.name}! This Website located at {this.props.store.url} (the "Site")
            is owned and operated by Bookspan, LLC (the "Company"). This Site and any purchases made
            through this Site are governed by the membership terms described below, as well as the
            terms of use and privacy policy found in the footer of the home page (“Terms”). You must
            be at least 18 years old to purchase products from this Site or use the {this.props.store.name}
            services. By using this Site, purchasing items through this Site, { ['CRS','SFC'].includes(this.props.store.tla) ? '' : `and/or enrolling in our
            ${this.props.store.name} Membership Program (which includes a monthly, automatic purchase feature as
            described below)` }, you agree to be bound by these terms, so please review this entire
            page carefully.
          </p>

          { this.props.store.tla == 'CRS' ? <div>
          <h6>
            Shutdown Notice
          </h6>
          <p>
            After 10/1/2025, orders will no longer be processed at Crossings.com. These terms of service were updated on 10/14/2024 to prepare for this change.
          </p>
          </div> : <div>
          <h6>HASSLE-FREE MEMBERSHIP </h6>
          <p>
            {this.props.store.name} has no commitments to purchase any books { ['CRS','SFC','HBC'].includes(this.props.store.tla) ? '' : 'or Member Credits' }, no automatic book shipments
            and you can cancel your membership at any time.
          </p>
            <h6>JOINING THE {this.props.store.name.toUpperCase()} MEMBERSHIP PROGRAM</h6>
          <p>
            To get started, simply click any of the “Join the Club” buttons on the Site, and enter your first name
            and a valid email address. There is no registration fee associated with submitting this information and
            no obligation to purchase.
          </p>
          <p>
            To become a {this.props.store.name} Member, add any item on this Site to your box and proceed to checkout. When
            you complete your purchase you can enroll in the {this.props.store.name} Membership Program by checking the
            appropriate box confirming your agreement to the membership terms.
          </p>          
          </div> }

          { ['CRS','SFC','HBC'].includes(this.props.store.tla) ? <div>
          <ul className="list">
            <li><strong>Cancel Your Account:</strong> You may cancel your membership at any time with no further obligation by contacting Member Services at {this.props.store.member_services_phone} </li>
          </ul>
          <p>
            You must keep a valid credit/debit card on file in order to be a
            {this.props.store.name} Member. If you do not provide a valid credit/debit card for two (2) or more consecutive
            months, we may cancel your membership, which will also permanently terminate any outstanding Member
            Credits on your account.
          </p>
          </div> : <div>
          <h6>HOW THE {this.props.store.name.toUpperCase()} MEMBERSHIP PROGRAM WORKS</h6>
          <p>
            As a {this.props.store.name} Member, you will receive an email on the 1st day of each month notifying you that your
            monthly Member Credits are available and announcing our latest Monthly Featured Selections, highlighting the
            best new books for readers like you. By the 10th of each month, you may select one of following options
            through your online account:
          </p>
          <ul className="list">
            <li><strong>Save Credits:</strong> When you select the Save Credits option, your credit/debit card will be charged ${this.props.store.two_credits} plus tax where applicable and you will receive 2 Member Credits for use on the site as described below.</li>
            <li><strong>Skip This Month:</strong> When you select the Skip This Month option, you will not receive any Member Credits for the month and your credit/debit card will not be charged.</li>
            <li><strong>Cancel Your Account:</strong> You may cancel your membership at any time with no further obligation by contacting Member Services at {this.props.store.member_services_phone} </li>
          </ul>
          <p>
            If you do not select one of the options above by the 10th day of the month, your credit/debit card on
            file will be charged ${this.props.store.two_credits} plus tax, where applicable, on the 11th day of the month, and 2 new Member
            Credits will be saved to your account. You must keep a valid credit/debit card on file in order to be a
            {this.props.store.name} Member. If you do not provide a valid credit/debit card for two (2) or more consecutive
            months, we may cancel your membership, which will also permanently terminate any outstanding Member
            Credits on your account.
          </p>    
          </div> }



          <h6>{this.props.store.name.toUpperCase()} MEMBERSHIP – MEMBER CREDITS</h6>
          <p>
            <span>{memberCreditCopy}</span> If you have multiple credits, you may redeem them together or
            separately, in a single month or gradually over time. Member Credits may only be redeemed for books
            during the term of your membership and cannot be redeemed or returned for cash. Member Credits are
            valid as long as your membership remains active and there is no limit to the number of credits that
            you can save to your account. No full or partial refunds will be provided for any unused Member Credits.
            If there are unredeemed Member Credits on your account when your membership is canceled or terminated for
            any reason, your Member Credits will be forfeited.
          </p>

          <h6>{this.props.store.name.toUpperCase()} MEMBERSHIP – MEMBER PRICING & PROMOTIONS</h6>
          <p>
            As a {this.props.store.name} Member, you will be able to purchase {this.props.store.name} titles at discounted Member’s- only
            prices. {this.props.store.name} books may differ in certain respects from publisher’s editions. From time to time,
            {this.props.store.name} provides its members with special promotional offers. All promotional offers are subject to
            specific rules and regulations, which will be clearly explained via a link on the site. From time to time,
            you will also receive emails advising you about your account and promotions, newsletters, special offers
            and other updates to maximize your reading experience. You can decide which promotional emails you want to
            receive by visiting the Account Section of this website. We may share your information with other clubs or
            websites operated by our parent or affiliated companies. From time to time, {this.props.store.name} may arrange for
            other companies to provide you with offers for products or services.
          </p>

          <h6>SHIPPING</h6>
          <p>
            Standard Shipping is free for all orders of three or more books; certain exclusions may apply from time to
            time. Standard shipping and processing on a purchase of 1 book is $5.99. You can find your order details
            and tracking information (when available) on the Purchase History tab within the Account section. If shipment
            of your order is delayed, we will notify you via email.
          </p>

          <h6>RETURNS</h6>
          <p>
            If for any reason you are not happy with your purchase, you can return it for a Member Credit (if purchased
            using a Member Credit) or a refund, subject to the following terms and limitations. We only accept returns
            received within 30 days from the original date of shipment. If you return a purchase made with a Member Credit,
            a Member Credit will be added back to your {this.props.store.name} account. For all other returns, the payment method used
            for the purchase will be credited. Shipping and processing fees, if applicable, will not be refunded. Any returned
            item must be in new, unused and resalable condition, and should be sent back in the original packaging. To
            make a return, please follow these steps:
          </p>
          <ol>
            <li>Call our toll free number at {this.props.store.member_services_phone}. Our Member Services team will email you our pre-paid return shipping label.</li>
            <li>Return the item in its original packaging.</li>
            <li>Attach the pre-paid return shipping label to your shipment and drop it off at any USPS location.</li>
          </ol>

          <h6>SALES TAX</h6>
          <p>
              {this.props.store.name} is required to collect sales tax when applicable.
          </p>

          <h6>PAYMENT OPTIONS</h6>
          <p>
            The credit/debit card you provide will be used for all future purchases and charges, including purchases of Member Credits.
            You must keep a valid credit/debit card on file during the term of your membership and you must keep us up-to-date with
            accurate member information, including your name, address, credit or debit card number and expiration date. You agree that
            we may update your information with information your bank or credit card issuer may supply.
          </p>
          <p>
            Once you become a member, if you wish to change your credit/debit card, just visit the “Account” section of our website.
            You can also change or edit your payment method when placing an order or making a payment with your credit/debit card. We
            will continue to apply your payments under this payment method unless you change your payment preference in the account section
            of the website, or notify us through Member Services to change your billing preference. We accept payment by credit/debit card
            (i.e., American Express, VISA, Discover and MasterCard).
          </p>
          <p>
            If you have selected a credit or debit card as your payment method and the charge cannot be processed on that card (for example,
            the card has expired or we cannot obtain authorization from your card issuer), then for your convenience, we will attempt to
            charge any other credit or debit card that you have placed on file with us, in order to prevent disruption of your membership. We
            are not responsible for any fees or charges that your bank, credit card or debit card issuer may apply. If your credit card issuer
            reverses a charge to your credit card, we may bill your account directly and seek payment by another method through a mailed
            statement. We may report information about your account to credit bureaus.
          </p>

          <h6>FOR PERSONAL USE ONLY</h6>
          <p>
            All products purchased through {this.props.store.name} are intended for personal use only and not for resale or any other commercial purpose.
            We reserve the right to cancel the account of any member suspected of violating this requirement and may limit the number of
            copies/titles that may be ordered on any account.
          </p>

          <h6>NOTICE OF ARBITRATION AGREEMENT</h6>
          <p>
            Bookspan LLC and you agree to arbitrate all disputes and claims between us arising out of or relating to this Agreement, as broadly
            interpreted to include any aspect of our relationship, including claims related to advertising. You thus give up your right to go to
            court, except that you may bring an action against us in small claims court. The arbitration will be under the prevailing Commercial
            Arbitration Rules and the Supplementary Procedures for Consumer Related Disputes of the American Arbitration Association
            (the “AAA Rules”), as modified by this Agreement. The AAA Rules, including how to initiate a claim, are available online at
            www.adr.org or by calling the AAA at 800-778-7879. If you choose arbitration, your rights will be determined by a neutral arbitrator
            and not by a judge or jury. You are entitled to a fair hearing, but arbitration procedures are simpler and more limited than rules
            applicable in court. Arbitrator decisions are as enforceable as any court order and are subject to very limited review by a court.
          </p>
          <p>
            Arbitrations will be conducted by one Arbitrator and will be Desk Arbitrations unless you or we request a Telephonic Hearing (as
            defined by AAA Rules). There will be no In-Person Hearing unless a claim seeks more than $75,000. We will pay all filing,
            Administration, and arbitrator fees, unless the Arbitrator finds that your claim had no reasonable foundation or was brought for an
            improper purpose, in which case the Arbitrator must order you to pay those costs. After you notify us that you have commenced
            arbitration, we will promptly reimburse you the filing fee. If the Arbitrator issues an award in your favor on the merits of your
            claim that is greater than the value of our last written settlement offer made before the Arbitrator was selected, then the
            arbitrator also may award you your reasonable attorney’s fees. We will not seek attorney’s fees from you even if we prevail. The
            arbitrator will be bound by this Agreement.
          </p>
          <p>
            The Arbitrator may award declaratory or injunctive relief only in favor of the party seeking relief and only as necessary to provide
            relief warranted by that party's individual claim. You and Bookspan LLC agree that each may bring claims against the other only in
            your or our individual capacity, and not as a plaintiff or class member in any purported class or representative proceeding.
            Further, unless both you and Bookspan LLC agree otherwise, the Arbitrator may not consolidate more than one person's claims, and
            may not otherwise preside over any form of a representative or class proceeding. If this specific provision is found to be
            unenforceable, then the entirety of this arbitration provision shall be null and void.
          </p>

          <h6>CHANGES TO MEMBERSHIP</h6>
          <p>
            We're always looking at ways to improve your membership experience. Accordingly, please note that {this.props.store.name} services, promotions,
            policies, benefits, charges, programs, and Terms are subject to change at any time. Please check here periodically for updates. We
            will always notify you in advance of any changes, either via email or via our Site. By enrolling and continuing to use or purchase
            products from this Site and/or continuing your membership, you accept and agree to the Terms and any changes so long as they are
            promptly posted on the Site or emailed to the email account we have on record for you. If you If you do not wish to be bound to
            these Terms (or any revisions to these Terms), please do not use this Site or the Company's services and immediately cancel your
            {this.props.store.name} Membership without further obligation by calling one of our member services representatives at {this.props.store.member_services_phone}
          </p>
          <p>
            We reserve the right to request additional information, reject any application, or cancel any membership.
          </p>
        </div>
      </div>
    );
  }
};


function mapStateToProps(state){
    return { 'store': state.store };
}

export default connect(mapStateToProps)(TermsOfMembership);


// WEBPACK FOOTER //
// ./src/components/CmsTermsOfMembership.jsx